import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconButton from 'components/common/IconButton';
import IconMoveVert from 'components/icons/IconMoveVert';

import Menu from 'components/common/Menu';
import DeleteMenu from 'components/common/DeleteMenu';
import Link from 'components/common/Link';
import Tooltip from 'components/common/Tooltip';

import formatUtcToLocalDate from 'utils/formatUtcToLocalDate';

import timeDateFormat from 'config/timeDateFormat';
import dateFormat from 'config/dateFormat';

const styles = theme => ({
  root: {
    paddingTop: 4,
    paddingBottom: 4,
  },
  gridItemShrink: {
    flexShrink: 1,
  },
  linkRemove: {
    paddingTop: 10,
    paddingBottom: 10,
    marginTop: -10,
    marginBottom: -8,
    marginLeft: 8,
  },
  buttonMove: {
    marginTop: -16,
    marginLeft: -16,
    position: 'relative',
    top: 1,
  },
  iconMoveVert: {
    width: 10,
    height: 16,
  },
  typographyDXCode: {
    minWidth: 81,
  },
  typographyExpire: {
    minWidth: 77,
    marginRight: 4,
    backgroundColor: theme.palette.validation[300],
  },
  desktopOnly: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
});

class DiagnosesItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };

    this.onMenuClose = this.onMenuClose.bind(this);
    this.onRemoveButtonClick = this.onRemoveButtonClick.bind(this);
    this.onRemoveCancel = this.onRemoveCancel.bind(this);
    this.onRemoveSubmit = this.onRemoveSubmit.bind(this);
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onRemoveButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
    });
  }

  onRemoveCancel() {
    this.setState({ anchorEl: null });
  }

  onRemoveSubmit() {
    this.setState({ anchorEl: null });
    this.props.onRemove();
  }

  render() {
    const { ID, business, dragHandleClassName, dragDisabled, dragged, classes } = this.props;
    const open = Boolean(this.state.anchorEl);
    return (
      <Grid
        className={classes.root}
        container
        spacing={0}
        wrap="nowrap"
        justify="space-between"
        alignItems="flex-start"
      >
        <Grid
          className={classes.gridItemShrink}
          item
        >
          <Grid
            container
            spacing={0}
            wrap="nowrap"
            alignItems="flex-start"
          >
            <Grid item>
              <IconButton
                className={classNames(classes.buttonMove, dragHandleClassName)}
                disabled={dragDisabled}
                tooltipContent={(!dragDisabled && !dragged) ? 'Drag it to Change Position' : null}
              >
                <IconMoveVert className={classes.iconMoveVert} />
              </IconButton>
            </Grid>
            <Grid item>
              
              {(this.props['Expire At'] && moment(this.props['Expire At'], dateFormat).isSameOrBefore(moment())) ? (     
                <Tooltip
                  content={
                    <Typography>
                      Expired At: {this.props['Expire At']}
                    </Typography>
                  }
                  placement="top"
                >
                  <Typography className={classes.typographyExpire}>
                    {this.props['DX Code']}
                  </Typography>
                </Tooltip>
              ) : (
                <Typography className={classes.typographyDXCode}>
                  {this.props['DX Code']}
                </Typography>
              )}
            </Grid>
            <Grid className={classNames(classes.gridItemShrink, classes.desktopOnly)} item>
              <Typography>
                {this.props['Long Description']}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid
            container
            spacing={0}
            wrap="nowrap"
            alignItems="center"
          >
            <Grid item>
              <Typography
                component="time"
                color="secondary"
                dateTime={formatUtcToLocalDate(
                  this.props['Link At'],
                  timeDateFormat,
                  dateFormat,
                  business['Company Address']['Time Zone'],
                  business['Company Address']['Observes Daylight Saving'],
                )}
              >
                {formatUtcToLocalDate(
                  this.props['Link At'],
                  timeDateFormat,
                  dateFormat,
                  business['Company Address']['Time Zone'],
                  business['Company Address']['Observes Daylight Saving'],
                )}
              </Typography>
            </Grid>
            <Grid item>
              <Link
                className={classes.linkRemove}
                color="primary"
                bold
                size="sm"
                aria-label="Remove"
                aria-owns={open ? `${ID}-diagnosis-remove-menu` : null}
                aria-haspopup="true"
                onClick={this.onRemoveButtonClick}
              >
                Remove
              </Link>
              <Menu
                id={`${ID}-diagnosis-remove-menu`}
                anchorEl={this.state.anchorEl}
                open={open}
                onClose={this.onMenuClose}
                list={false}
              >
                <DeleteMenu
                  text="Are you sure you want to delete this diagnosis?"
                  onCancel={this.onRemoveCancel}
                  onSubmit={this.onRemoveSubmit}
                />
              </Menu>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

DiagnosesItem.propTypes = {
  ID: PropTypes.number.isRequired,
  'Link At': PropTypes.string,
  'DX Code': PropTypes.string.isRequired,
  'Long Description': PropTypes.string.isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  dragHandleClassName: PropTypes.string,
  dragDisabled: PropTypes.bool,
  dragged: PropTypes.bool,
  onRemove: PropTypes.func,
  classes: PropTypes.shape({
    linkRemove: PropTypes.string.isRequired,
    gridItemShrink: PropTypes.string.isRequired,
    buttonMove: PropTypes.string.isRequired,
    iconMoveVert: PropTypes.string.isRequired,
    typographyDXCode: PropTypes.string.isRequired,
  }).isRequired,
};

DiagnosesItem.defaultProps = {
  'Link At': null,
  business: {},
  dragHandleClassName: '',
  dragDisabled: false,
  dragged: false,
  onRemove: () => {},
};

export default withStyles(styles)(DiagnosesItem);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Diagnoses/DiagnosesItem.js